import { Icon } from '@/common/components/Icons/Icon';
import { Label } from '@/common/components/Label/Label';
import { Stack } from '@/common/components/Stack/Stack';
import * as SwitchPrimitive from '@rn-primitives/switch';
import { BodyText } from '../BodyText/BodyText';
import { styles } from './Switch.styles';
import { TSwitchProps } from './Switch.types';

export function Switch({
  className,
  checked,
  onChange,
  disabled,
  variant,
  label,
  description,
}: TSwitchProps) {
  return (
    <Stack horizontal gap="sm" className={className}>
      <SwitchPrimitive.Root
        className={styles.root({ checked, disabled })}
        checked={checked}
        onCheckedChange={onChange}
        aria-label={label}
        disabled={disabled}
      >
        <SwitchPrimitive.Thumb className={styles.thumb({ checked })}>
          {checked && (
            <Icon
              icon="check"
              color={disabled ? 'neutral20' : 'accentPrimary10'}
              size={14}
            />
          )}
        </SwitchPrimitive.Thumb>
      </SwitchPrimitive.Root>
      {variant === 'descriptive' && (
        <Stack>
          <Label bold color={checked ? 'neutral30' : 'neutral20'}>
            {label}
          </Label>
          {description && (
            <BodyText size="sm" color="neutral20">
              {description}
            </BodyText>
          )}
        </Stack>
      )}
    </Stack>
  );
}
